import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDf11TeW6FpIyIVcpKL8TgjzpYuUGJIZqI",
  authDomain: "groupyarn-9a203.firebaseapp.com",
  projectId: "groupyarn-9a203",
  storageBucket: "groupyarn-9a203.firebasestorage.app",
  messagingSenderId: "494162637212",
  appId: "1:494162637212:web:c8a853c7e646f54c4d1859",
  measurementId: "G-MT0SNDL6FR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);